import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  HStack,
  Text,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'neurev_cookie_consent';

const CookieConsent: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Small delay so it slides in after the page loads
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex={9999}
      bg="gray.900"
      color="white"
      px={{ base: 4, md: 8 }}
      py={4}
      borderTop="1px solid"
      borderColor="gray.700"
      boxShadow="0 -4px 24px rgba(0,0,0,0.3)"
      style={{ animation: 'slideUp 0.35s ease-out' }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
      `}</style>

      <HStack
        gap={4}
        justify="space-between"
        align={{ base: 'start', md: 'center' }}
        flexDirection={{ base: 'column', md: 'row' }}
        maxW="7xl"
        mx="auto"
      >
        <Text fontSize="sm" color="gray.300" maxW="3xl">
          {t('landing.cookieConsentText')}{' '}
          <RouterLink to="/privacy" style={{ color: '#63b3ed', textDecoration: 'underline' }}>
            {t('landing.privacyPolicy')}
          </RouterLink>
          .
        </Text>

        <HStack gap={3} flexShrink={0}>
          <Button
            size="sm"
            colorScheme="blue"
            onClick={accept}
          >
            {t('landing.cookieGotIt')}
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
};

export default CookieConsent;
